module.exports = __webpack_public_path__ + "custom-config/img/renzhenglianmeng@2x.828f805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/renzhenglianmeng@2x.png
// module id = wTUH
// module chunks = 2 3 4 6 7 8 9